export const shape = {
  borderRadius: 8,
} as const;
